import routes from './routes';
import { SetRoutes } from 'components';

const InterviewsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InterviewsPages;
